var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { StickyFilters } from '@web/components/Filters/StickyFilters';
import { SelectUserCards } from '@web/components/PerformanceReview/Employee/SelectUserCards';
import { IndividualCommTime } from '@web/components/PerformanceReview/Manager/IndividualCommTime';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { NavigateTo } from '@web/router/NavigateTo';
import { settingsUrl } from '@web/router/urls';
import { filterUsersByOrgUnitAndRole, getUserOrgUnit } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { settingsActiveTabs } from '@web/utility/tabs';
import { UserRoles } from '@workalizer/shared';
import { Trans } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
export var ManagerTab = function () {
    var _a, _b;
    var _c = useFilters(), userId = _c.user, orgUnit = _c.orgUnit, dateFrom = _c.dateFrom, dateTo = _c.dateTo;
    var users = useWorkspaceCtx().users;
    var location = useLocation();
    var user = users.find(function (u) { return u.id === userId; });
    var isSelectedUserManager = (user === null || user === void 0 ? void 0 : user.role) === UserRoles.MANAGER;
    if (userId) {
        var userOrgUnit = getUserOrgUnit(user);
        var needsReset = !isSelectedUserManager;
        var needsOrgUnit = isSelectedUserManager && userOrgUnit && !orgUnit;
        if (needsReset || needsOrgUnit) {
            return (_jsx(NavigateTo, { pathname: location.pathname, newFilters: needsReset
                    ? { user: null, orgUnit: null }
                    : { orgUnit: userOrgUnit } }));
        }
    }
    var filteredUsers = filterUsersByOrgUnitAndRole(users, orgUnit, UserRoles.MANAGER);
    var orgUnitId = orgUnit || ((_a = user === null || user === void 0 ? void 0 : user.orgUnit) === null || _a === void 0 ? void 0 : _a.id);
    var userBelongsToOrgUnit = !orgUnit || ((_b = user === null || user === void 0 ? void 0 : user.orgUnit) === null || _b === void 0 ? void 0 : _b.id) === orgUnit;
    var showUserCards = !user || !isSelectedUserManager || !userBelongsToOrgUnit;
    return (_jsxs(_Fragment, { children: [_jsx(StickyFilters, { users: {
                    showAllOption: false,
                    isOpenByDefault: false,
                    isDefaultUserSelected: false,
                    role: UserRoles.MANAGER
                }, orgUnits: {
                    showAllOption: true,
                    autoSelectFirstUser: true,
                    userRole: UserRoles.MANAGER,
                    hideAllWhenUserSelected: true
                } }), showUserCards && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "mt-4 mb-4 rounded-md border border-sky-200 bg-sky-50 px-4 py-3 text-sm text-sky-800" }, { children: _jsx(Trans, { i18nKey: "app.performanceReview.managerPerformanceReview.managerSelectionNotice", components: {
                                linkToSettingsUsers: (_jsx(Link, { to: "".concat(settingsUrl, "/").concat(settingsActiveTabs.users), className: "underline" }))
                            } }) })), _jsx(SelectUserCards, { users: filteredUsers })] })), user &&
                isSelectedUserManager &&
                userBelongsToOrgUnit &&
                userId &&
                orgUnitId && (_jsx("div", __assign({ className: "mt-6" }, { children: _jsx(IndividualCommTime, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo }) })))] }));
};
